export const shortenAddress = (
  address: string,
  startDigits = 6,
  endDigits = 4
) => {
  if (!address) return "";
  return `${address.slice(0, startDigits)}...${address.slice(-endDigits)}`;
};

export const debounce = <Params extends unknown[]>(
  func: (...args: Params) => void,
  wait: number
) => {
  let timeout: NodeJS.Timeout;
  return (...args: Params) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

export const getNetwordIcon = (chainId: number) => {
  switch (chainId) {
    case 56:
      return "/images/bnb.png";
    case 1:
      return "/images/eth-item.png";
    case 43114:
      return "/images/avax.png";
    case 8453:
      return "/images/base.png";
    case 137:
      return "/images/poly.png";
    case 42161:
      return "/images/arb.png";
    default:
      return "/images/eth-item.png";
  }
};
